import React, { useState } from 'react'
import axios from 'axios';

const Formulario = ({english, showAlert, status, setSending}) => {
    const [info, setInfo] = useState({
        nombre: '',
        email: '',
        telefono: '',
        productoInteres: '',
        comentario: ''
    })

    const handlerInputs = e => {
        setInfo({
            ...info,
            [e.target.name] : e.target.value
        })
    }

    const handleSendDataToApi = async() => {
        let valid = validarFormulario()
        if(valid) {
            axios.post(
                "https://cabomarques.gmd.mx/api-email/email.php",
                info
            ).then((response) => {
                console.log(response)
                if(response.data.sent) {
                    showAlert('Gracias por contactarnos. Nos pondremos en contacto contigo a la brevedad', 'success')
                    setInfo({
                        nombre: '',
                        email: '',
                        telefono: '',
                        productoInteres: '',
                        comentario: ''
                    })
                } else {
                    showAlert('Ha ocurrido un error. Intenta más tarde.', 'error')
                }
            })
        }
    }

    const validarFormulario = () => {
        //e.preventDefault()
        if (info.nombre === '' || info.email === '' || info.telefono === '' || info.comentario === '' || info.productoInteres === '') {
           showAlert('Todos los campos son requeridos', 'error') 
           return false
        }
        //e.currentTarget.submit()
        return true
    }

    return ( 
        // <form onSubmit={validarFormulario} method="post" className="formulario" action="https://cabomarques.excite.cloud/api-email/email.php">
        <div className="formulario">
            <input 
                type="text" 
                name="nombre"
                className="form-input"
                placeholder={english? 'name' : 'nombre'}
                onChange={handlerInputs}
                value={info.nombre}
            />
            <input 
                type="text" 
                name="email"
                className="form-input"
                placeholder="e-mail"
                onChange={handlerInputs}
                value={info.email}                
            />
            <input 
                type="text" 
                name="telefono"
                className="form-input"
                placeholder={english? 'telephone' : 'teléfono'}
                onChange={handlerInputs}
                value={info.telefono}                
            />
            <select 
                name="productoInteres" 
                className="form-input"
                onChange={handlerInputs}
                value={info.productoInteres}
            >
                <option defaultChecked>{english ? 'product of interest' : 'producto de interés'}</option>
                <option value="3">{english ? 'Lot' :'Macrolote'} 3</option>
                <option value="6a">{english ? 'Lot' :'Macrolote'} 6a</option>
                <option value="9">{english ? 'Lot' :'Macrolote'} 9</option>
                <option value="11c2a">{english ? 'Lot' :'Macrolote'} 11c2a</option>
                <option value="11c2b">{english ? 'Lot' :'Macrolote'} 11c2b</option>
                <option value="11c1">{english ? 'Lot' :'Macrolote'} 11c1</option>
                <option value="12a">{english ? 'Lot' :'Macrolote'} 12a</option>
                <option value="12b">{english ? 'Lot' :'Macrolote'} 12b</option>
                <option value="16a">{english ? 'Lot' :'Macrolote'} 16a</option>
                <option value="22">{english ? 'Lot' :'Macrolote'} 22</option>
                <option value="23d">{english ? 'Lot' :'Macrolote'} 23d</option>
                <option value="26">{english ? 'Lot' :'Macrolote'} 26</option>                    
                <option value="banyan-tree">Banyan Tree</option>
                <option value="marina-cabo-marques">La Marina Cabo Marqués</option>
                <option value="los-riscos">Los Riscos Cabo Marqués</option>
            </select>
            <textarea 
                name="comentario" 
                className="form-input"
                placeholder={english? 'comments' : 'comentarios'}
                onChange={handlerInputs}
                value={info.comentario}                
            ></textarea>
            
            <button 
                // type="submit" 
                style={{display: 'block', marginLeft: 'auto'}}
                className="btn btn-oscuro"
                //value=
                onClick={() => handleSendDataToApi()}
            > {english ? 'SEND' : 'enviar'} </button>
        </div>
        // </form>
     );
}
 
export default Formulario;
